export const ChangePasswordFormFields = {
  currentPassword: 'currentPassword',
  newPassword: 'newPassword',
  confirmNewPassword: 'confirmNewPassword',
  mfaCode: 'mfaCode',
} as const;

export type ChangePasswordFormValues = {
  [ChangePasswordFormFields.currentPassword]: string;
  [ChangePasswordFormFields.newPassword]: string;
  [ChangePasswordFormFields.confirmNewPassword]: string;
  [ChangePasswordFormFields.mfaCode]?: string;
};
